import type { ICustomerMfeNotesCall } from '@servicetitan/contactcenter-agent-inbox-mfe-loader';
import type { ITask } from '../types';

const MIN_PHONE_DIGITS = 10;

/**
 * Builds the notes call for a task whose call is live.
 *
 * `callerNumber` is `task.from`, trimmed and otherwise as held (unformatted),
 * only when it has at least 10 digits, so a blank, `anonymous` or internal
 * `User...` caller gives none. `linkedCustomerId` is the task's linked
 * customer id as a string, only when one is set.
 *
 * @param task The task whose call is live.
 * @param sid The live call's SID (from `liveCallSid`).
 */
export function toNotesCall(
  task: Pick<ITask, 'from' | 'attributes'>,
  sid: string,
): ICustomerMfeNotesCall {
  const from = (task.from ?? '').trim();
  // Same check as InboxModule's isFromInternalUser.
  const isFromInternalUser = from.startsWith('User');
  const customerId = task.attributes?.customerId;

  return {
    sid,
    ...(!isFromInternalUser &&
    from.replace(/\D/g, '').length >= MIN_PHONE_DIGITS
      ? { callerNumber: from }
      : {}),
    ...(customerId ? { linkedCustomerId: String(customerId) } : {}),
  };
}
